// ABOUTME: Normalizes WhatsApp API response bodies returned by server controllers.
// ABOUTME: Handles direct and nested response envelopes used across WhatsApp screens.
const WHATSAPP_RESPONSE_KEYS = [
    "authUrl",
    "candidate",
    "conversations",
    "activePhoneNumberId",
    "connection",
    "connected",
    "config",
    "featureEnabled",
    "hasStoredConnection",
    "inactiveReason",
    "messages",
    "items",
    "matches",
    "options",
    "operationId",
    "phoneNumbers",
    "selectionRequired",
    "selectionSessionId",
    "success",
    "templates",
    "ticket",
    "results",
    "eligibleIds",
    "flow",
    "attachmentId",
    "link",
    "links",
    "uploadURL",
    "uploadMethod",
    "uploadFields",
    "s3Key",
    "url",
    "version"
];

export const getWhatsappApiResponseData = (response: any): Compleo.IObject => {
    const body = response?.data || {};
    const nestedBody = body?.data;

    if (
        nestedBody &&
        typeof nestedBody === "object" &&
        !Array.isArray(nestedBody) &&
        WHATSAPP_RESPONSE_KEYS.some((key) =>
            Object.prototype.hasOwnProperty.call(nestedBody, key)
        )
    ) {
        return nestedBody;
    }

    return body;
};
